class Welcome {
    /*
     * @description: 创建一个新评论
     */
    static say () {
        console.log('hello world')
    }
}

export default Welcome;


// WEBPACK FOOTER //
// ./src/model/Welcome.js